module.exports = __webpack_public_path__ + "static/media/loading.70121042.gif";